import { render } from "./FindParent.vue?vue&type=template&id=1ea8d2f3&scoped=true&ts=true"
import script from "./FindParent.vue?vue&type=script&lang=ts"
export * from "./FindParent.vue?vue&type=script&lang=ts"

import "./FindParent.vue?vue&type=style&index=0&id=1ea8d2f3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea8d2f3"]])

export default __exports__